export var version = '3.6.9';
//# sourceMappingURL=version.js.map